import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { AgreementDocument } from '../index';
import { useAgreementDocumentModal } from './hooks';

export const AgreementDocumentModal = () => {
  const { agreementDocument, isOpenAgreementModal, setIsOpenAgreementModal } = useAgreementDocumentModal();
  return (
    <ModalBase
      modalStyle={ModalStyle.confirmModal}
      isOpen={isOpenAgreementModal}
      onRequestClose={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          return;
        }
        setIsOpenAgreementModal(false);
      }}
      children={
        <AgreementDocument
          agreementDocument={agreementDocument}
          onRequestClose={() => {
            setIsOpenAgreementModal(false);
          }}
        />
      }
      shouldCloseOnOverlayClick={false}
    />
  );
};
